import { api } from "../../@vendor/utils";
import { createCancelTokenHandler } from "../../@vendor/utils/services/cancel-token.service";
import { AxiosPromise } from "axios";
import { ICreateRepository } from "../../@vendor/utils";
import { CreateBooking } from "../../models/Booking";

const endPoint = () => window._env_.REACT_APP_PASSPORT_END_POINT;

interface IBookingCounselingRepository {
  create(payload: any): AxiosPromise<any>;
}

const BookingCounselingRepository: IBookingCounselingRepository = {
  create(payload) {
    return api.post(`${endPoint()}/api/v2/booking-counseling`, payload, {
      cancelToken:
        cancelTokenHandlerObject[this.create.name].handleRequestCancellation()
          .token,
    });
  },
};

const cancelTokenHandlerObject = createCancelTokenHandler(
  BookingCounselingRepository
);

export default BookingCounselingRepository;
